var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.26,
    height: 20.018,
    viewBox: "0 0 11.26 20.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-outline_Arrow_-_Left_2",
    "data-name": "Iconly/Light-outline/Arrow - Left 2",
    transform: "translate(-7.5 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_-_Left_2",
    "data-name": "Arrow - Left 2",
    transform: "translate(7.5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow_-_Left_2-2",
    "data-name": "Arrow - Left 2",
    d: "M10.953.3a1.015,1.015,0,0,1,.1,1.341l-.1.115L2.536,10.009l8.417,8.251a1.015,1.015,0,0,1,.1,1.341l-.1.115a1.066,1.066,0,0,1-1.368.1l-.118-.1L.308,10.737A1.015,1.015,0,0,1,.206,9.4l.1-.115L9.467.3A1.065,1.065,0,0,1,10.953.3Z",
    transform: "translate(0)",
    fill: "#818181"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.7e303ac701cbe5c67a1ec4dfdfca7b19.svg";
export { ForwardRef as ReactComponent };